export const formatLabel = key =>
  key.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');

export const CONDITION_OPTIONS = [
  { value: 'condition-like-new', label: 'Like New' },
  { value: 'condition-good', label: 'Good' },
  { value: 'condition-fair', label: 'Fair' },
  { value: 'condition-poor', label: 'Poor' },
];
